import React, { useRef } from 'react';

import { FormikHelpers } from 'formik';

import OnboardingSelect from 'components/Selects/OnboardingSelect';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Error } from './styles';

interface Props {
  id?: string;
  type?: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  formik?: FormikHelpers<string>;
}

const SeatSelector = ({ value, formik, error, disabled }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const { t } = useStoreTranslation();
  const SEAT_TYPES = [
    { id: '', name: t('seatSelector.noPrefer') },
    { id: 'Window', name: t('seatSelector.window') },
    { id: 'Middle', name: t('seatSelector.middle') },
    { id: 'Hall', name: t('seatSelector.hall') },
  ];

  const handleChange = (newValue: any) => formik?.setFieldValue('seatType', newValue);

  return (
    <div ref={ref}>
      <OnboardingSelect
        disabled={disabled}
        title={t('seatSelector.title')}
        options={SEAT_TYPES}
        value={value}
        onChange={handleChange}
      />
      {error && <Error>{error}</Error>}
    </div>
  );
};

export default SeatSelector;
